export default __webpack_public_path__ + "static/media/defaultBook.58a418ee.png";